import { render, staticRenderFns } from "./ViewUserPage.vue?vue&type=template&id=59d217ea&scoped=true&"
import script from "./ViewUserPage.vue?vue&type=script&lang=js&"
export * from "./ViewUserPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserPage.vue?vue&type=style&index=0&id=59d217ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d217ea",
  null
  
)

export default component.exports